import { useEffect } from 'react';

import type { FullPageEditorPresetAPI } from '@confluence/editor-presets/entry-points/useFullPageEditorPreset.ts';
import { useDocChangeContext } from '@confluence/editor-features/entry-points/useDocChangeContext.ts';
import { useLiveDocsFlagToShare } from '@confluence/experiment-twcg-2055-flag-to-share/entry-points/useLiveDocsFlagToShare.ts';

type LiveDocsFlagToShareSideEffectProps = {
	contentId: string;
	editorApi: FullPageEditorPresetAPI | undefined;
};

/** Conditionally mounted by editor side effects to wire document changes into Flag-to-Share criteria. */
export const LiveDocsFlagToShareSideEffect = ({
	contentId,
	editorApi,
}: LiveDocsFlagToShareSideEffectProps): null => {
	const { subscribeDocChange, unsubscribeDocChange } = useDocChangeContext();
	const handleDocChange = useLiveDocsFlagToShare(editorApi, {
		contentId,
		isLivePage: true,
	});

	useEffect(() => {
		if (!handleDocChange) {
			return;
		}

		subscribeDocChange(handleDocChange);
		return () => unsubscribeDocChange(handleDocChange);
	}, [handleDocChange, subscribeDocChange, unsubscribeDocChange]);

	return null;
};
